import * as React from 'react'

import * as styles from './marketingBlock.module.css'

interface IProps {
  imgSrc: string
  title: string
  description: string
}

const MarketingBlock = ({ imgSrc, title, description }: IProps) => {
  return (
    <article className={styles.root}>
      <header>
        <div className={styles.imgWrapper}>
          <img alt={title} src={imgSrc} />
        </div>
        <p className={styles.title}>{title}</p>
      </header>
      <section className={styles.description}>{description}</section>
    </article>
  )
}

export default MarketingBlock
